/**
 * Gravity Forms multi-file upload widget ("Orbital" theme) — enforce the
 * Bosnian labels client-side as well as server-side.
 *
 * The PHP `gettext` filter (includes/gform-i18n.php) already translates
 * these strings at render time, but the plupload/moxie runtime that powers
 * this widget can redraw the browse button after that initial render (its
 * own JS carries a hardcoded/localized English default) — so the fix
 * needs to hold even if something re-sets the text after page load. A
 * MutationObserver re-applies the translation any time it drifts, on top
 * of an immediate pass on load. Scoped to .inquiry-form only; only touches
 * text content, never attributes/handlers, so the button keeps opening
 * the native file picker exactly as before.
 */

const LABELS = {
	'.gform_button_select_files': 'Odaberite fajlove',
};

function applyLabels(root) {
	Object.entries(LABELS).forEach(([selector, label]) => {
		root.querySelectorAll(selector).forEach((el) => {
			if (el.textContent.trim() !== label) {
				el.textContent = label;
			}
		});
	});
}

export default function gformUploadI18n() {
	const forms = document.querySelectorAll('.inquiry-form');
	if (!forms.length) {
		return;
	}

	forms.forEach((form) => {
		applyLabels(form);

		const observer = new MutationObserver(() => applyLabels(form));
		observer.observe(form, { childList: true, subtree: true, characterData: true });
	});
}
